module.exports = __webpack_public_path__ + "img/q-10-4@2x.c32b176e.png";